const PARAMETROS_SSO_TOKEN = 'ssoToken';
const SSO_TOKEN_STORAGE_KEY = 'ssoToken';

export const aplicarSsoTokenDaUrl = () => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get(PARAMETROS_SSO_TOKEN);

    if (!token) {
        return;
    }

    sessionStorage.setItem(SSO_TOKEN_STORAGE_KEY, token);
    url.searchParams.delete(PARAMETROS_SSO_TOKEN);
    const novaUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, document.title, novaUrl);
};

export const buscarSsoTokenStorage = () => {
    return sessionStorage.getItem(SSO_TOKEN_STORAGE_KEY);
};

export const possuiSsoTokenStorage = () => {
    return Boolean(buscarSsoTokenStorage());
};
